// extracted by mini-css-extract-plugin
export default {"textLink":"DepreciationScheduleManagementTable_textLink__9bcIS"};